import {
  DecisionContext,
  DecisionTypeHandler,
  DbotEventDispatcher,
} from "@/dbot/common/commonDomain";
import { CompanyNameChange, CompanyNameChangeForm, handleEvent } from "./companyNameChangeDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<CompanyNameChange>,
  data?: CompanyNameChange,
): CompanyNameChangeForm {
  return new CompanyNameChangeForm(dispatch, context, data);
}

export function isValid(form: CompanyNameChangeForm): boolean {
  return form.isValid;
}

export function validate(form: CompanyNameChangeForm): boolean {
  return form.validate();
}

export function applyForm(form: CompanyNameChangeForm): CompanyNameChange {
  return {
    type: DecisionType.companyName,
    newCompanyName: form.newCompanyName.validatedValue,
    articleOfAssociationNumber: form.articleOfAssociationNumber?.selected,
  };
}

export const companyNameHandler: DecisionTypeHandler<
  DecisionType.companyName,
  CompanyNameChange,
  CompanyNameChangeForm
> = {
  type: DecisionType.companyName,
  initNewForm,
  isValid,
  validate,
  applyForm,
  handleEvent,
};
